import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Alert,
  Spinner,
} from "react-bootstrap";
import axiosInstance from "../../api/axiosInstance";
import colors from "../../constants/colors";

import {
  FaPhone,
  FaEnvelope,
  FaClock,
  FaFacebook,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa";

const ContactsPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [validated, setValidated] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity()) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setSubmitting(true);
    setSubmitError("");

    try {
      await axiosInstance.post("/contact", formData);
      setSubmitSuccess(true);
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
      setValidated(false);
    } catch (error) {
      setSubmitError(
        "Ocorreu um erro ao enviar a tua mensagem. Por favor tenta novamente."
      );
      console.error("Error sending contact form:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container className="py-5">
      <h1 className="text-center mb-5" style={{ color: colors.dark }}>
        Contacta-me
      </h1>

      <Row className="justify-content-center">
        <Col md={5} className="mb-4 mb-md-0">
          <Card
            className="h-100 shadow-sm"
            style={{ borderColor: colors.secondary }}
          >
            <Card.Body className="p-4">
              <h2 className="mb-4" style={{ color: colors.dark }}>
                Informações de Contacto
              </h2>

              <div className="mb-4">
                <div className="d-flex align-items-start mb-3">
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: colors.secondary,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "15px",
                    }}
                  >
                    <FaPhone style={{ color: colors.light }} />
                  </div>
                  <div>
                    <h5 className="mb-0" style={{ color: colors.dark }}>
                      Telefone
                    </h5>
                    <p className="mb-0" style={{ color: colors.textGray }}>
                      +351 916 444 093
                    </p>
                  </div>
                </div>

                <div className="d-flex align-items-start mb-3">
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: colors.secondary,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "15px",
                    }}
                  >
                    <FaEnvelope style={{ color: colors.light }} />
                  </div>
                  <div>
                    <h5 className="mb-0" style={{ color: colors.dark }}>
                      Email
                    </h5>
                    <p className="mb-0" style={{ color: colors.textGray }}>
                      geral@marciamaio.pt
                    </p>
                  </div>
                </div>

                <div className="d-flex align-items-start">
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: colors.secondary,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "15px",
                    }}
                  >
                    <FaClock style={{ color: colors.light }} />
                  </div>
                  <div>
                    <h5 className="mb-0" style={{ color: colors.dark }}>
                      Horário
                    </h5>
                    <p className="mb-0" style={{ color: colors.textGray }}>
                      Segunda a Sexta: 9h às 18h
                    </p>
                  </div>
                </div>
              </div>

              <h4 className="mb-3" style={{ color: colors.dark }}>
                Segue-me
              </h4>
              <div className="social-links">
                <a
                  href="https://www.facebook.com/marciamaio.organiza"
                  className="me-3"
                  style={{ color: colors.dark }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook size="1.5em" />
                </a>
                <a
                  href="https://www.instagram.com/marciamaio.organiza"
                  className="me-3"
                  style={{ color: colors.dark }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram size="1.5em" />
                </a>
                <a
                  href="https://www.tiktok.com/@marciamaio.organiza"
                  className="me-3"
                  style={{ color: colors.dark }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTiktok size="1.5em" />
                </a>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={7}>
          <Card className="shadow-sm" style={{ borderColor: colors.secondary }}>
            <Card.Body className="p-4">
              <h2 className="mb-4" style={{ color: colors.dark }}>
                Envia-me uma Mensagem
              </h2>

              {submitSuccess ? (
                <Alert
                  variant="success"
                  style={{
                    backgroundColor: colors.success,
                    color: colors.light,
                    borderColor: colors.success,
                  }}
                >
                  <h5>Mensagem enviada com sucesso!</h5>
                  <p className="mb-0">
                    Obrigada por me contactares. Responderei o mais brevemente
                    possível.
                  </p>
                </Alert>
              ) : (
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  {submitError && (
                    <Alert
                      variant="danger"
                      style={{
                        backgroundColor: colors.danger,
                        color: colors.light,
                        borderColor: colors.danger,
                      }}
                    >
                      {submitError}
                    </Alert>
                  )}

                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group controlId="name">
                        <Form.Label style={{ color: colors.dark }}>
                          Nome
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          disabled={submitting}
                          style={{ borderColor: colors.secondary }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Por favor insere o teu nome.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="email">
                        <Form.Label style={{ color: colors.dark }}>
                          Email
                        </Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          disabled={submitting}
                          style={{ borderColor: colors.secondary }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Por favor insira um email válido.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3" controlId="subject">
                    <Form.Label style={{ color: colors.dark }}>
                      Assunto
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      disabled={submitting}
                      style={{ borderColor: colors.secondary }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Por favor insira um assunto.
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="message">
                    <Form.Label style={{ color: colors.dark }}>
                      Mensagem
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows={5}
                      required
                      disabled={submitting}
                      style={{ borderColor: colors.secondary }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Por favor insere a tua mensagem.
                    </Form.Control.Feedback>
                  </Form.Group>

                  <div className="d-grid">
                    <Button
                      type="submit"
                      size="lg"
                      disabled={submitting}
                      style={{
                        backgroundColor: colors.secondary,
                        borderColor: colors.secondary,
                      }}
                    >
                      {submitting ? (
                        <>
                          <Spinner
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          />
                          A enviar...
                        </>
                      ) : (
                        "Enviar Mensagem"
                      )}
                    </Button>
                  </div>
                </Form>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactsPage;
